import React from 'react';
import './SvgLoader.css';

export interface SvgLoaderProps {
  svgPath?: string;
  svgImport?: string;
  svgContent?: React.ReactNode;
  color?: string;
  size?: number;
  opacity?: number;
  filter?: string;
  className?: string;
}

const SvgLoader: React.FC<SvgLoaderProps> = ({
  svgPath,
  svgImport,
  svgContent,
  color = '#000000',
  size = 100,
  opacity = 1,
  filter,
  className = ''
}) => {
  // Create CSS custom properties object
  const cssCustomProperties: Record<string, string> = {
    '--svg-width': `${size}px`,
    '--svg-height': `${size}px`,
    '--svg-opacity': opacity.toString(),
    '--svg-fill': color,
  };

  // Add filter if provided
  if (filter) {
    cssCustomProperties['--svg-filter-override'] = filter;
  }

  // Create data attributes for dynamic properties
  const dataAttributes = {
    'data-dynamic-size': size !== 100 ? 'true' : undefined,
    'data-dynamic-color': color !== '#000000' ? 'true' : undefined,
    'data-dynamic-filter': filter ? 'true' : undefined,
  };

  const combinedClassName = `svg-loader ${className}`.trim();

  // If svgContent is provided, use it directly
  if (svgContent) {
    return (
      <div 
        className={combinedClassName} 
        style={cssCustomProperties}
        data-testid="svg-loader"
        {...dataAttributes}
      >
        {svgContent}
      </div>
    );
  }

  // If svgImport is provided, use it as img src (for imported SVGs from src/)
  if (svgImport) {
    return (
      <img
        src={svgImport}
        alt="SVG"
        className={combinedClassName}
        style={cssCustomProperties}
        data-testid="svg-loader"
        {...dataAttributes}
      />
    );
  }

  // If svgPath is provided, use it as img src (for SVGs in public/)
  if (svgPath) {
    return (
      <img
        src={svgPath}
        alt="SVG"
        className={combinedClassName}
        style={cssCustomProperties}
        data-testid="svg-loader"
        {...dataAttributes}
      />
    );
  }

  // No SVG content provided
  return null;
};

export default SvgLoader;